/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';
import { ModalTitleProps } from 'types/components/Modal';
import { Close } from '..';

export default function ModalTitle({
  title,
  subtitle,
  titleIcon,
  avatar,
  closeModal,
}: ModalTitleProps): JSX.Element | null {
  if (!avatar && !subtitle && !title && !titleIcon) {
    return null;
  }
  return (
    <div className="title-container" id="ModalTitle_container">
      {avatar && avatar}
      {titleIcon && <span id="ModalTitle_icon" className={`title-icon ${titleIcon}`} />}
      {title && (
        <span id="ModalTitle_title" className="title">
          {title}
        </span>
      )}
      {subtitle && (
        <span id="ModalTitle_subtitle" className="subtitle">
          {subtitle}
        </span>
      )}
      {closeModal && <Close bemBlock="Modal" action={closeModal} isActive />}
    </div>
  );
}
